export default "__VITE_ASSET__9da3a585__"